var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.cellStyle),on:{"mousedown":_vm.mousedown,"mouseup":_vm.mouseup,"mousemove":_vm.mousemove}},[_vm._v(_vm._s(_vm.word))])}
var staticRenderFns = []

export { render, staticRenderFns }